import type React from 'react';

import { Button, Description } from '@gitbook/spine-react';

import { AnimatedAgentIcon } from '../Agent/AnimatedAgentIcon';
import type { AgentChatBlankslateProps } from '../AgentChat';
import { RequestFeatureButton } from '../Feedback';

const SUGGESTIONS = [
    'Review my changes',
    'Suggest improvements on this page',
    'Fix all typos and grammatical errors',
];

/**
 * Blankslate when starting a new conversation with the agent.
 */
export function AgentChangeRequestBlankslate(props: AgentChatBlankslateProps) {
    const { postMessage } = props;

    return (
        <AgentBlankslateLayout>
            {SUGGESTIONS.map((suggestion) => (
                <Button
                    kind="pill"
                    size="small"
                    key={suggestion}
                    label={suggestion}
                    onPress={() => {
                        postMessage(suggestion);
                    }}
                />
            ))}
        </AgentBlankslateLayout>
    );
}

/**
 * Blankslate when the feature is not enabled.
 */
export function AgentBlankslateRequestAccess() {
    return (
        <AgentBlankslateLayout>
            <div className="flex flex-col items-center gap-2">
                <Description className="text-center">
                    Brainstorm, plan, and implement changes with Docs Agents.
                </Description>
                <RequestFeatureButton flagKey="DOCS_AGENTS" />
            </div>
        </AgentBlankslateLayout>
    );
}

function AgentBlankslateLayout(props: React.PropsWithChildren) {
    const { children } = props;
    return (
        <div className="flex flex-1 flex-col items-center justify-center gap-3">
            <div className="shimmer flex size-16 items-center justify-center rounded-full border border-base">
                <AnimatedAgentIcon size={40} loop={false} />
            </div>
            <div className="flex flex-col gap-2 px-8">{children}</div>
        </div>
    );
}
